import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=4bfab06f"
import script from "./ButtonLink.vue?vue&type=script&lang=ts"
export * from "./ButtonLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports